import { patch } from '../../../../infra/rest';

export const assignChatToUser = async (
  chatId: string,
  customerId: string,
  userId: string
): Promise<boolean> => {
  if (!chatId) return false;

  await patch<{ success: boolean }>(
    `/v2/conversation/${chatId}/assign`,
    {
      body: JSON.stringify({
        teamId: 'DEFAULT_TEAM',
        userId,
        customerId,
      }),
    },
    true
  );

  return true;
};

export const assignMultipleChatsToUser = async (
  chatIds: string[],
  userId: string
): Promise<{}> => {
  return patch(
    `/v1/conversation/assign-multiple`,
    {
      body: JSON.stringify({ teamId: 'DEFAULT_TEAM', userId, chatIds }),
    },
    true
  );
};
